import { useMemo } from 'react';
import toLowerCase from 'utils/toLowerCase';
import type { RefundDrawerDataSource, RefundDrawerRow, RefundDrawerType } from '../types';
import type { CancelOrder } from 'services/api/refund';

const defaultTextReasonTrans = {} as Record<string, string>;

function dataSourceResolve(
  row: RefundDrawerRow,
  type: RefundDrawerType,
): RefundDrawerDataSource & Record<string, unknown> {
  if (type === 'cancel') {
    const data = row as CancelOrder;
    return {
      externalBuyerId: data.buyerId,
      internalStoreId: data.storeId,
      externalStoreId: data.externalStoreId,
      orderSn: data.orderId,
      returnStatus: data.orderState,
      returnSn: data.reverseOrderId,
      refundAmount: data.totalAmount,
      buyerNick: data.buyerName,
      region: toLowerCase(data.region),
      textReason: row.reason,
      textReasonTrans: defaultTextReasonTrans,
    };
  }
  return row as unknown as RefundDrawerDataSource & Record<string, unknown>;
}

/**
 * 统一退款/取消抽屉数据源。
 * 将取消单（CancelOrder）转换为与退货单兼容的字段结构，便于后续逻辑复用。
 */
export function useRefundDrawerDataSource(row: RefundDrawerRow, type: RefundDrawerType) {
  const dataSource = useMemo(() => dataSourceResolve(row, type), [row, type]);
  const isRefund = type === 'refund';

  return { dataSource, isRefund };
}
